import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'

const CreateVolumeModal = ({ isOpen, onClose, data, onSubmit }) => {
  const validationSchema = yup.object().shape({
    year: yup.number().required('წელიწადი უნდა დაიწეროს რიცხვებით'),
    volume: yup.number().required('გამოშვების ნომერი უნდა დაიწეროს რიცხვებით'),
  })

  const initialValues = {
    year: data?.year || 0,
    volume: data?.volume || 0,
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>ახალი ტომის დამატება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}>
          <Form>
            <div className='flex flex-col gap-4 p-3.5'>
              <span>
                <label htmlFor='year' className='text-lg'>
                  წელი
                </label>
                <Field
                  className='border rounded py-2'
                  autoComplete='off'
                  type='number'
                  id='inputCreatePost'
                  name='year'
                  placeholder='2027'
                />
                <ErrorMessage style={{ color: 'red' }} name='year' component='span' />
              </span>
              <span>
                <label htmlFor='volume' className='text-lg'>
                  სტატიის ნომერი
                </label>
                <Field
                  className='border rounded py-2'
                  autoComplete='off'
                  type='number'
                  id='inputCreatePost'
                  name='volume'
                  placeholder='74'
                />
                <ErrorMessage style={{ color: 'red' }} name='volume' component='span' />
              </span>

              <div className='flex flex-row items-center gap-3 justify-end w-full'>
                <Button variant='primary' type='submit'>
                  {data ? 'შეცვლა' : 'დამატება'}
                </Button>
                <Button onClick={onClose}>Cancel</Button>
              </div>
            </div>
          </Form>
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default CreateVolumeModal
